import { Roles } from 'src/app/shared/enums/Roles.enum';

/** Risk's strip on the operation page: «Detalle de operación», «Riesgos», «Observaciones» — no «Contactos» (QA, 2026-10-26). */
const RISK_ANALYST_TAB_COUNT = 3;

/**
 * The tab to open on. The remembered tab index is shared by every role and was saved when Risk's strip still had four tabs, so a Risk user can come
 * back with an index past the end of the three-tab strip. That index would open no tab at all; it opens the first one instead. Every other role keeps
 * the index it saved.
 */
export function operationTabIndexForRole(role: string | undefined | null, index: number): number {
  if (role !== Roles.RISK_ANALYST) return index;
  return Number.isInteger(index) && index >= 0 && index < RISK_ANALYST_TAB_COUNT ? index : 0;
}
